import CategorySection from "../../component/design-system/category-selection/CategorySection";
import CategorySlectionCardBig from "../../component/design-system/category-selection/CategorySlectionCardBig";
import ArticleItem from "../../component/landing-page/article-item/ArticleItem";
import ModelCard from "./common/ModelCard";
import RelatedProducts from "./common/RelatedProducts";

const DYNAMIC_SECTION_TYPE = {
  // Make Pages
  ALL_MODELS: "all-models",
  MAKE_TIER: "links.popularMakeCategories",
  MAKE_MODEL_TIER: "links.popularMakeModelCategories",
  RELATED_PRODUCTS: "relatedProducts",
  INTRODUCTION: "introduction",
  ARTICLE: "article",
  // make-model page
  ALL_YEARS: "all-years",
  TIERS_MAKE_MODEL_PAGES: "tiersMakeModelPagesWithUrl",
  YEAR_MAKE_MODEL_TIER: "tiersYearMakeModelPagesWithUrl",
};

function DynamicOrderComponents(props: any) {
  const {
    pageStructure,
    modelData, make, popularMakeCategories, relatedProducts, popularMakeModelCategories,
    makeModelCategoryUrls, model, tiersYearMakeModelPagesWithUrl,
    displayableMake = make, displayableModel = model, displayableYear = "",
  } = props;

  const displayName = [displayableYear, displayableMake, displayableModel].filter(Boolean).join(" ");

  if (!(pageStructure && Array.isArray(pageStructure) && pageStructure.length)) {
    return null;
  }

  return pageStructure.map((_, index) => {
    const { type } = _;
    switch (type) {
    case DYNAMIC_SECTION_TYPE.ALL_MODELS:
      return (
        <CategorySection {...{
          categoryUrls: modelData,
          maxRows: 3,
          key: type,
          title: `All ${displayName} Models`,
          searchPlaceholder: "Filter Model",
          handleSearchValueHandler: (searchPhrase: string) => {
            const filteredData = modelData.filter((eachData) => eachData.displayableModel.toLowerCase().startsWith(searchPhrase.toLowerCase()));
            return filteredData;
          },
        }}
        >

          <ModelCard make={make} />
        </CategorySection>
      );
    case DYNAMIC_SECTION_TYPE.MAKE_TIER:
      return (
        <CategorySection {...{
          categoryUrls: popularMakeCategories,
          maxRows: 3,
          key: type,
          title: `Popular ${displayName} Categories`,
          imageProps: { width: 200, height: 100 },
          blueBorderOnHover: true,
        }}
        >

          <CategorySlectionCardBig
            imageProps={{ width: 200, height: 100 }}
          />
        </CategorySection>
      );
    case DYNAMIC_SECTION_TYPE.MAKE_MODEL_TIER:
      return (
        <CategorySection {...{
          categoryUrls: popularMakeModelCategories,
          maxRows: 2,
          key: type,
          title: `Pick Parts For Your ${displayName} Model`,
        }}
        >

          <CategorySlectionCardBig />
        </CategorySection>
      );
    case DYNAMIC_SECTION_TYPE.YEAR_MAKE_MODEL_TIER:
      return (
        <CategorySection {...{
          categoryUrls: tiersYearMakeModelPagesWithUrl,
          maxRows: 2,
          key: type,
          title: `Popular ${displayName} Categories `,
        }}
        >

          <CategorySlectionCardBig />
        </CategorySection>
      );
    case DYNAMIC_SECTION_TYPE.RELATED_PRODUCTS:
      return (
        <RelatedProducts
          key={type}
          products={relatedProducts}
          title={`Recommended ${displayName} Products`}
        />
      );
    case DYNAMIC_SECTION_TYPE.ARTICLE:
      return <ArticleItem key={`${type}-${index}`} {..._.article} headingType="h2" />;
      // case DYNAMIC_SECTION_TYPE.ALL_YEARS:
      //   return (
      //     <CategorySection {...{
      //       key: type, categoryUrls: yearsWithUrl, label: "year", title: `Select Your ${displayName} Year`,
      //     }}
      //     >
      //       <ModelCard
      //         jsLink
      //         onClick={(e: any, { year: selectedYear }) => {
      //           dispatch(addVehicle({ make, model, year: selectedYear }, true));
      //         }}
      //       />
      //     </CategorySection>
      //   );
    case DYNAMIC_SECTION_TYPE.TIERS_MAKE_MODEL_PAGES:
      return (
        <CategorySection
          maxRows={3}
          key={type}
          title={`Popular ${displayName} Categories `}
          {...{ categoryUrls: makeModelCategoryUrls }}
        >

          <CategorySlectionCardBig
            imageProps={{ width: 200, height: 200 }}
          />
        </CategorySection>
      );
    default:
      return null;
    }
  });
}

export default DynamicOrderComponents;
